import Styled from 'styled-components'
import { Checkbox } from 'primereact/checkbox'

export const PrimeCheckbox = Styled(Checkbox)`
  min-width: 25px;
`
